export const projectQueryKeys = {
  all: ['projects'],
  experiments: () => [...projectQueryKeys.all, 'experiments'],
  experiment: (id) => [...projectQueryKeys.experiments(), id],
  details: () => [...projectQueryKeys.all, 'detail'],
  detail: (id) => [...projectQueryKeys.details(), id], 
  pagination: (page) => [...projectQueryKeys.all, 'pagination', page],
  infinite: () => [...projectQueryKeys.all, 'infinite'],
};